/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { KTIcon, toAbsoluteUrl } from '../../../helpers'
import { Dropdown1 } from '../../content/dropdown/Dropdown1'
import { useNavigate } from 'react-router-dom'

type Props = {
  className: string
  linkTo?: string
  cleanUpData?: any
}

const TablesWidget2: React.FC<Props> = ({ className, linkTo = '', cleanUpData }) => {
  const navigate = useNavigate()

  let dataArray: any[] = []
  if (cleanUpData) {
    dataArray = Array.isArray(cleanUpData)
      ? cleanUpData
      : cleanUpData.data && Array.isArray(cleanUpData.data)
        ? cleanUpData.data
        : []
  }

  const hasData = dataArray.length > 0

  const renderTableBody = () => {
    if (!hasData) {
      return (
        <tr>
          <td>
            <div className='symbol symbol-50px me-2'>
              <span className='symbol-label'>
                <img
                  src={toAbsoluteUrl('/media/svg/brand-logos/plurk.svg')}
                  className='h-50 align-self-center'
                  alt=''
                />
              </span>
            </div>
          </td>
          <td>
            <a href='#' className='text-dark fw-bold text-hover-primary mb-1 fs-6'>
              Top Authors
            </a>
            <span className='text-dark fw-semibold d-block fs-7'>Successful Fellas</span>
          </td>
          <td className=''>
            <span className='badge badge-light-danger fw-semibold me-1'>Angular</span>
            <span className='badge badge-light-info fw-semibold me-1'>PHP</span>
          </td>
          <td className=''>
            <span className='text-dark fw-semibold'>4600 Users</span>
          </td>
        </tr>
      )
    }

    return dataArray.map((item: any, index: number) => (
      <tr key={item.id || index}>
        <td>
          <div className='symbol symbol-50px me-2'>{item?.pickupPointName || 'N/A'}</div>
        </td>
        <td>
          <a href='#' className='text-dark fw-bold text-hover-primary mb-1 fs-6'>
            {item?.customerName || 'Top Authors'}
          </a>

          {/* <span className='text-dark fw-semibold d-block fs-7'>
            {item?.source || 'Successful Fellas'}
          </span> */}


          <span className='text-dark fw-semibold d-block fs-7'>
            {item?.customerInfo?.customerType || 'Successful Fellas'}
          </span>

        </td>
        {/* <td className=''>
          <span className='badge badge-light-danger fw-semibold me-1'>
            {item?.orderDetails?.[0]?.categoryName || 'Angular'}
          </span>
          <span className='badge badge-light-info fw-semibold me-1'>
            {item?.orderDetails?.[0]?.items?.[0]?.itemName || 'PHP'}
          </span>
        </td> */}


        <td className=''>
          <div className='d-flex flex-column align-items-start gap-1'>
            <span className='badge badge-light-danger fw-semibold'>
              {item?.orderDetails?.[0]?.categoryName || 'Angular'}
            </span>
            <span className='badge badge-light-info fw-semibold'>
              {item?.orderDetails?.[0]?.items?.[0]?.itemName || 'PHP'}
            </span>
          </div>
        </td>


        <td className=''>
          {/* <span className='text-dark fw-semibold'> */}
          <span className='badge badge-light fw-bold my-2 text-black'>
            {/* {item?.orderDetails?.[0]?.items?.[0]?.quantity || 0} */}
            {(item?.orderDetails?.[0]?.items?.[0]?.quantity || 0).toFixed(2)}
          </span>
        </td>
      </tr>
    ))
  }

  return (
    <div className={`card ${className}`}>
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>Material Inward</span>
          <span className='text-dark mt-1 fw-semibold fs-7'>Last 10 data</span>
        </h3>
        <div className='card-toolbar'>
          <button
            type='button'
            onClick={() => navigate(linkTo)}
            className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary'
            data-kt-menu-trigger='click'
            data-kt-menu-placement='bottom-end'
            data-kt-menu-flip='top-end'
          >
            View More
          </button>
          <Dropdown1 />
        </div>
      </div>
      <div className='card-body py-3'>
        <div className='table-responsive'>
          <style>{`
      #unique-table-12345 thead tr th,
      #unique-table-12345 th {
        background-color: white !important;
        background: white !important;
        background-image: none !important;
      }
    `}</style>

          <table className='table align-middle gs-0 gy-5' id="unique-table-12345">
            <thead>
              <tr>
                <th className='p-0 min-w-150px'>Facility Name</th>
                <th className='p-0 min-w-150px'>Supplier</th>
                <th className='p-0 min-w-150px'>Material</th>
                <th className='p-0 min-w-90px'>Quantity</th>
              </tr>
            </thead>
            <tbody>{renderTableBody()}</tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export { TablesWidget2 }
